<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header @change="_search" hint="Ketik no. invoice" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Penjualan</h2>
                <div>
                  Periode transaksi: {{ dataFilter.start_date }} -
                  {{ dataFilter.end_date }}
                </div>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto">
                    <div class="input-icon float-left">
                      <span class="input-icon-addon">
                        <i class="fe fe-align-left"></i>
                      </span>
                      <select class="form-control" v-model="paginate.perPage" @change="
                        reload = 0;
                      _get();
                      " :disabled="loading">
                        <option :value="num" :key="i" v-for="(num, i) in [10, 50, 100, 999]"
                          v-html="num == 999 ? 'Semua' : num" />
                      </select>
                    </div>

                    <button class="btn btn-white ml-3" v-html="ic('filter')" @click="_filter" />

                    <div class="btn-group ml-3">
                      <button class="btn btn-outline-primary" @click="_printInvoice"
                        v-html="ic('download') + 'Cetak Invoice'" />
                      <button class="btn btn-primary" v-html="ic('plus') + 'Tambah'" @click="_add" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Skeleton type="table" :length="15" class="mt-3 bg-white" v-if="loading" />

          <Nodata v-if="!loading && data.length == 0" />

          <div class="box" v-if="!loading && data.length > 0">
            <div class="card">
              <div class="table-responsive">
                <table class="table table-vcenter table-hover card-table table-striped">
                  <thead>
                    <tr class="text-muted">
                      <th>No</th>
                      <th>Comp</th>
                      <th>No. Nota</th>
                      <th>Toko</th>
                      <th>Salesman</th>
                      <th>Tgl PO</th>
                      <th>Pembayaran</th>
                      <th >Jml Print</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Tgl Transaksi</th>
                      <th>Tgl Pelunasan</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in  data " :key="i" :class="i == 0 && paginate.currentPage == 1 ? animate : ''
                      ">
                      <td v-html="i + paginate.fromPage"></td>
                      <td>
                        <span class="badge bg-blue-lt mr-2" v-html="row.kode_perusahaan" />
                      </td>
                      <td nowrap class="click-able text-primary" @click="_detail(row)">
                        {{ "PO: " + row.id }} <br />
                        {{ row.no_invoice }}
                      </td>
                      <td :class="{
                        'text-danger': row.toko[0].status_verifikasi == 'N',
                        'text-primary': row.id_mitra != 0,
                      }">
                        <span v-html="'[' + row.toko[0].no_acc + ']'" />
                        <span class="badge bg-danger" v-if="row.pending_status !== null" v-html="row.pending_status" />
                        <div v-html="row.toko[0].nama_toko" />
                      </td>
                      <td nowrap>
                        {{ row.nama_tim }} -
                        {{ row.salesman[0].nama_salesman.slice(0, 10) }}
                      </td>
                      <td nowrap v-html="dateFormat(row.tanggal)" />
                      <td class="text-center" v-html="row.tipe_pembayaran" />
                      <td class="text-center">
                        <span v-if="row.invoice_type == 'proforma'" :class="'badge w-100 bg-warning'" style="font-size: 12px;">{{row.print_count}}</span>
                        <span v-if="row.invoice_type == 'invoice'" :class="'badge w-100 bg-success'" style="font-size: 12px;">{{row.print_count_invoice}}</span>
                      </td>
                      <td nowrap style="vertical-align: center">
                        <ul class="pl-0" style="list-style-type: none; margin-top: 10px">
                          <li>
                            <span v-html="row.status" class="badge w-100" :class="statusClass[row.status]" />
                          </li>
                          <li v-if="row.status == 'approved' && row.tanggal_jadwal != null && row.driver_id != null">
                           <span v-html="'Scheduled'" class="badge w-100" :class="'bg-gray'" />
                          </li>
                          <li>
                            <span v-html="row.invoice_type != null ? row.invoice_type : 'no invoice'" class="badge w-100"
                              :class="row.invoice_type != null ? invoiceTypeClass[row.invoice_type] : 'bg-default'" />
                          </li>
                        </ul>
                      </td>
                      <td nowrap style="vertical-align: center">
                        <ul class="p-0" style="list-style-type: none; margin-top: 10px">
                          <li v-if="row.created_at != ''">
                            <span title="Tanggal Created" class="btn btn-sm btn-warning" v-html="row.created_at" />
                          </li>
                          <li v-if="row.approved_at != ''">
                            <span title="Tanggal Approved" class="btn btn-sm btn-success" v-html="row.approved_at" />
                          </li>
                          <li v-if="row.delivered_at != ''">
                            <span title="Tanggal Delivered" class="btn btn-sm btn-info" v-html="row.delivered_at" />
                          </li>
                          <li v-if="row.deleted_at != ''">
                            <span title="Tanggal Deleted" class="btn btn-sm btn-danger" v-html="row.deleted_at" />
                          </li>
                        </ul>
                      </td>
                      <td>
                        <span v-if="row.paid_at">
                          {{ dateFormat(row.paid_at + '|ymd', '-') }}
                        </span>
                        <span v-else>
                          Belum Lunas
                        </span>
                      </td>
                      <td class="p-0">
                        <b-dropdown variant="link" size="lg" dropleft no-caret>
                          <template slot="button-content">
                            <i class="fe fe-more-vertical"></i>
                          </template>

                          <b-dropdown-item @click="_detail(row)">
                            Rincian Penjualan
                          </b-dropdown-item>
                          <b-dropdown-item @click="_updatePayment(row)" v-if="access.includes('Update Payment Penjualan')">
                            Update Tipe Pembayaran
                          </b-dropdown-item>
                          <template v-if="row.status == 'delivered' && (row.gudang.vendor == null || row.id_gudang !== 91)">
                            <b-dropdown-item @click="_cancelAsSent(row.id)"
                              v-if="(access.includes('Menu Group Administrator') || access.includes('Undeliver Penjualan Forced') || access.includes('Hapus Tanggal Terima Penjualan'))">
                              Batalkan Status Terkirim
                            </b-dropdown-item>
                            <b-dropdown-item @click="_editDueDate(row)">
                              Update Due Date
                            </b-dropdown-item>
                          </template>

                          <template v-if="row.status == 'delivered'">
                            <b-dropdown-item @click="_setProformaToInvoice(row.id)"
                                v-if="row.invoice_type == 'proforma' && access.includes('Ubah Proforma Menjadi Invoice')">
                                Ubah Proforma Menjadi Invoice
                              </b-dropdown-item>
                          </template>
                          
                          <b-dropdown-item @click="_setInvoiceToProforma(row.id)"
                            v-if="
                              row.invoice_type == 'invoice' && access.includes('Ubah Invoice Menjadi Proforma') && 
                              row.status == 'delivered' && row.gudang.jenis != 'canvass'
                            ">
                            Ubah Invoice Menjadi Proforma
                          </b-dropdown-item>

                          <template
                            v-if="(row.status == 'approved' || row.status == 'loaded') &&  (row.gudang.vendor == null || row.id_gudang !== 91) ">
                            <b-dropdown-item @click="_markAsSent(row.id)">
                              Tandai Terkirim
                            </b-dropdown-item>
                          </template>

                          <template
                            v-if="(row.status == 'waiting' || row.status == 'approved' || row.status == 'loaded')">
                            <b-dropdown-item @click="_updateEta(row.id)">
                              Edit ETA
                            </b-dropdown-item>
                          </template>

                          <template v-if="row.status == 'delivered' && row.invoice_type == 'proforma'">
                            <b-dropdown-item @click="_editQty(row)"
                              v-if="access.includes('Edit Quantity Detail Penjualan')">
                              Edit Detail atau Quantity
                            </b-dropdown-item>
                          </template>

                          <template v-if="row.status == 'waiting'">
                            <b-dropdown-item @click="_edit(row)">
                              Edit
                            </b-dropdown-item>
                            <b-dropdown-item @click="_closed(row)">
                              Batalkan
                            </b-dropdown-item>

                            <b-dropdown-item @click="_delete(row.id)">
                              Hapus
                            </b-dropdown-item>
                          </template>
                          <template>
                            <b-dropdown-item v-if="_checkPenjualanVendorCanClose(row)" @click="_closedByVendor(row)">
                              Batalkan
                            </b-dropdown-item>
                          </template>
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-12 col-md-auto text-center">
                <button class="btn btn-outline-primary mr-3" @click="_pagePrev">
                  Prev
                </button>
                <button class="btn btn-outline-primary" @click="_pageNext">
                  Next
                </button>
              </div>
            </div>
          </div>

          <!-- <b-pagination
            v-if="data.length > 0 && !loading"
            align="center"
            class="mt-5"
            :total-rows="'1000'"
            v-model="paginate.currentPage"
            :per-page="paginate.perPage"
            @change="_pageChange"
          /> -->
        </div>
      </div>
    </div>

    <FormFilter :config.sync="filter.config" :initData="filter.data" :dismiss.sync="filter.dismiss"
      :isSubmit.sync="filter.isSubmit" @submit="filter.action" />

    <PrintInvoice :config.sync="invoice.config" :initData="invoice.data" :dismiss.sync="invoice.dismiss"
      :isSubmit.sync="invoice.isSubmit" @submit="invoice.action" />

    <FormPenjualanBaru :config.sync="penjualan.config" :initData="penjualan.data" :dismiss.sync="penjualan.dismiss"
      :isSubmit.sync="penjualan.isSubmit" @submit="penjualan.action" />

    <FormPenjualanBarang :config.sync="form.config" :initData="form.data" :dismiss.sync="form.dismiss"
      :isSubmit.sync="form.isSubmit" @submit="form.action" />

    <Confirm :id.sync="confirm.id" :title.sync="confirm.title" :subTitle.sync="confirm.subTitle"
      :isSubmit.sync="confirm.isSubmit" @submit="confirm.action" :btnConfirm.sync="confirm.btnConfirm"
      :textConfirm.sync="confirm.textConfirm" />

    <DetailPenjualan :config.sync="detail.config" :initData="detail.data" :dismiss.sync="detail.dismiss"
      :isSubmit.sync="detail.isSubmit" @approved="_setApproved" @submit="detail.action" :isEditDetail.sync="detail.isEditDetail" />

    <UpdatePaymentPenjualan :config.sync="updatePayment.config" :initData="updatePayment.data" :dismiss.sync="updatePayment.dismiss" @submit="updatePayment.action" />

    <DetailPenjualan :config.sync="editDetail.config" :initData="editDetail.data" :dismiss.sync="editDetail.dismiss"
      :isSubmit.sync="editDetail.isSubmit" @approved="_setApproved" @submit="editDetail.action" :isEditDetail.sync="editDetail.isEditDetail" />

    <MarkSent :config.sync="mark.config" :initData="mark.data" :dismiss.sync="mark.dismiss" :isSubmit.sync="mark.isSubmit"
      @submit="mark.action" />

    <SetEta :config.sync="eta.config" :initData="eta.data" :dismiss.sync="eta.dismiss" :isSubmit.sync="eta.isSubmit"
    @submit="eta.action" />

    <DueDate :config.sync="due.config" :initData="due.data" :dismiss.sync="due.dismiss" :isSubmit.sync="due.isSubmit"
      @submit="due.action" />

    <EditQuantity :config.sync="editQuantity.config" :initData="editQuantity.data" :dismiss.sync="editQuantity.dismiss"
      :isSubmit.sync="editQuantity.isSubmit" @submit="editQuantity.action" />

    <Closed :config.sync="closed.config" :initData="closed.data" :dismiss.sync="closed.dismiss"
      :isSubmit.sync="closed.isSubmit" @submit="closed.action" />

    <Confirm :id.sync="confirmResetFaktur.id" :title.sync="confirmResetFaktur.title"
      :subTitle.sync="confirmResetFaktur.subTitle" :isSubmit.sync="confirmResetFaktur.isSubmit"
      @submit="confirmResetFaktur.action" :btnConfirm.sync="confirmResetFaktur.btnConfirm"
      :textConfirm.sync="confirmResetFaktur.textConfirm" />

    <Confirm :id.sync="confirmSetInvoiceType.id" :title.sync="confirmSetInvoiceType.title"
      :subTitle.sync="confirmSetInvoiceType.subTitle" :isSubmit.sync="confirmSetInvoiceType.isSubmit"
      @submit="confirmSetInvoiceType.action" :btnConfirm.sync="confirmSetInvoiceType.btnConfirm"
      :textConfirm.sync="confirmSetInvoiceType.textConfirm" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import PrintInvoice from "./modals/print-invoice.vue";
import FormFilter from "./modals/filter.vue";
import FormPenjualanBarang from "./modals/form-penjualan-barang.vue";
import FormPenjualanBaru from "./modals/form-penjualan-baru.vue";
import DetailPenjualan from "./modals/detail-penjualan.vue";
import MarkSent from "./modals/mark-sent.vue";
import SetEta from "./modals/set-eta.vue";
import DueDate from "./modals/due-date.vue";
import Closed from "./modals/closed";
import EditQuantity from './modals/edit-quantity.vue';
import UpdatePaymentPenjualan from "@/pages/dashboard/sales/penjualan/modals/update-payment.vue";

const fb = require("@/db.js");
const now = new Date();

export default {
  name: "Penjualan",
  components: {
    UpdatePaymentPenjualan,
    PrintInvoice,
    FormFilter,
    FormPenjualanBarang,
    FormPenjualanBaru,
    DetailPenjualan,
    MarkSent,
    SetEta,
    DueDate,
    Closed,
    EditQuantity,
  },
  data() {
    return {
      auth: {},
      animate: null,
      reload: 0,
      access: [],

      filter: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      invoice: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      form: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      penjualan: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      mark: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      eta: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      due: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      editQuantity: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      closed: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => { },
      },

      confirm: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => { },
        subTitle: "Penghapusan ini bersifat permanen",
        btnConfirm: "btn-danger",
        textConfirm: "Hapus Sekarang",
      },

      confirmResetFaktur: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => { },
        subTitle: "Penghapusan No Pajak ini bersifat permanen",
        btnConfirm: "btn-danger",
        textConfirm: "Reset Sekarang",
      },

      confirmSetInvoiceType: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => { },
        subTitle: "Ubah invoice ini bersifat permanen",
        btnConfirm: "btn-success",
        textConfirm: "Ubah Invoice",
      },

      detail: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        isEditDetail: false,
        action: () => { },
      },

      updatePayment: {
        config: { view: false, title: null },
        data: null,
        action: () => { },
      },

      editDetail: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        isEditDetail: false,
        action: () => { },
      },

      loading: true,
      data: [],

      paginate: {
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fromPage: 0,
      },

      dataFilter: {
        page: 1,
        per_page: 10,
        keyword: "",
        id_perusahaan: "",
        depo: [],
        id_salesman: [],
        status_pending: "-",
        status: "all",
        tipe_pembayaran: "all",
        start_date: new Date(now.getFullYear(), now.getMonth() - 1, 2)
          .toISOString()
          .slice(0, 10),
        end_date: new Date(now.getFullYear(), now.getMonth() + 1, 2)
          .toISOString()
          .slice(0, 10),
      },

      statusClass: {
        waiting: "bg-orange",
        approved: "bg-green",
        loaded: "bg-info",
        delivered: "bg-info",
        closed: "bg-danger",
        cancel: "bg-danger",
        reject: "bg-danger",
      },

      invoiceTypeClass: {
        proforma: "bg-green",
        invoice: "bg-info",
      },

      invoiceTypeClass: {
        proforma: "bg-orange",
        invoice: "bg-green",
      },

      fireTrigger: null,
    };
  },

  mixins: [helper],

  methods: {
    _get(params) {
      this.loading = params == null ? true : !params.silent;

      this.dataFilter.page = this.paginate.currentPage;
      this.dataFilter.per_page = this.paginate.perPage;

      this.axios
        .get("penjualan", { params: this.dataFilter })
        .then((res) => {
          this.data = res.data.data;
          this.loading = false;

          this.paginate.totalRows = res.data.meta.total;
          this.paginate.fromPage = res.data.meta.from;
          this.paginate.to = res.data.meta.to;

          if (params != null && params.po != null) {
            this.penjualan.config.view = false;
            let added = this.data.find((item) => item["id"] == params.po);
            this._detail(added);
            this.toast("Berhasil ditambahkan");
          }

          // animasi penjualan baru
          if (this.reload > 1) {
            this.animate = "animate bounceIn";
            setTimeout(() => {
              this.animate = "";
            }, 1000);
          }

          if (this.reload < 2) {
            this.reload += 1;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.onError(err);
        });
    },

    _filter() {
      this.filter.config = { view: true, title: "Filter" };
      this.filter.action = (formData) => {
        for (const key in formData) {
          this.dataFilter[key] = formData[key];
        }
        this.paginate.currentPage = 1;
        this._get();
      };
    },

    _printInvoice() {
      this.invoice.config = { view: true, title: "Cetak Invoice Penjualan" };
    },

    _add() {
      this.penjualan.config = { view: true, title: "Penjualan Baru" };
      this.penjualan.data = null;
      this.penjualan.action = (formData) => {
        this.penjualan.isSubmit = true;
        this.axios
          .post("penjualan/web", formData)
          .then((res) => {
            this._get({ silent: true, po: res.data.id });
          })
          .catch((err) => {
            this.onError(err);
            this.penjualan.isSubmit = false;
          });
      };
    },

    _edit(data) {
      this.form.config = { view: true, title: "Edit Penjualan" };
      this.form.data = data;
      this.form.action = (formData) => {
        this.axios
          .put(
            "penjualan/" +
            data.id +
            "?per_page=" +
            this.paginate.perPage +
            "&page=" +
            this.paginate.currentPage,
            formData
          )
          .then((res) => {
            this.findObject(this.data, "id", data.id, (d, i) => {
              let _data = formData;
              for (const key in _data) {
                this.data[i][key] = _data[key];
              }
            });

            this.toast("Berhasil diperbarui");
            this.form.config.view = false;
          })
          .catch((err) => {
            this.onError(err);
            this.form.isSubmit = false;
          });
      };
    },

    _delete(id) {
      this.confirm.id = id;
      (this.confirm.title = "Yakin ingin menghapus data penjualan ini?"),
        (this.confirm.subTitle = "Penghapusan ini bersifat permanen");
      this.confirm.action = () => {
        let url =
          "penjualan/" +
          id +
          "?per_page=" +
          this.paginate.perPage +
          "&start_date=" +
          this.dataFilter.start_date +
          "&end_date=" +
          this.dataFilter.end_date +
          "&id_salesman=" +
          this.dataFilter.id_salesman;

        this.axios
          .delete(url)
          .then((res) => {
            this._get({ silent: true });
            this.toast("Berhasil dihapus");
            this.confirm.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirm.isSubmit = false;
          });
      };
    },

    _markAsSent(id) {
      this.mark.config = { view: true, title: "Tandai Sebagai Terkirim" };
      this.mark.data = null;
      this.mark.action = (formData) => {
        this.mark.isSubmit = true;

        this.axios
          .post("penjualan/deliver/" + id, formData)
          .then((res) => {
            this.findObject(this.data, "id", id, (key) => {
              this.data[key].status = "delivered";
            });

            this.toast("Ditandai terkirim");
            this.mark.isSubmit = false;
          })
          .catch((err) => {
            this.onError(err);
            this.mark.isSubmit = false;
          });
      };
    },

    _cancelAsSent(id) {
      this.confirm.id = id;
      this.confirm.title =
        "Yakin ingin membatalkan penjualan ini sudah terkirim?";
      this.confirm.subTitle = "Status penjualan akan kembali menjadi approved";
      this.confirm.btnConfirm = "btn-primary";
      this.confirm.textConfirm = "Batalkan Tandai Terkirim";
      this.confirm.action = () => {
        this.axios
          .post("penjualan/undeliver/" + id)
          .then((res) => {
            this.findObject(this.data, "id", id, (key) => {
              this.data[key].status = "approved";
            });

            this.toast("Ditandai terkirim dibatalkan");
            this.confirm.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirm.isSubmit = false;
          });
      };
    },

    _updateEta(id) {
      this.eta.config = { view: true, title: "Edit ETA" };
      this.eta.data = null;
      this.eta.action = (formData) => {
        this.eta.isSubmit = true;

        this.axios
          .post("penjualan/set_eta/" + id, formData)
          .then((res) => {
            this.findObject(this.data, "id", id, (key) => {
              this.data[key].eta = formData.eta;
              formData.eta = null;
            });

            this.toast("Update ETA berhasil");
            this.eta.isSubmit = false;
          })
          .catch((err) => {
            this.onError(err);
            this.eta.isSubmit = false;
          });
      };
    },

    _editDueDate(data) {
      let id = data.id;
      this.due.config = { view: true, title: "Ubah Due Date" };
      this.due.data = data;
      this.due.action = (formData) => {
        this.due.isSubmit = true;
        this.axios
          .put(`penjualan/${id}/update_due_date`, formData)
          .then((res) => {
            this.toast("Due date berhasil diubah");
            this.due.isSubmit = false;
          })
          .catch((err) => {
            this.onError(err);
            this.due.isSubmit = false;
          });
      };
    },

    _setProformaToInvoice(id) {
      this.confirmSetInvoiceType.id = id;
      this.confirmSetInvoiceType.title = "Yakin ingin mengubah proforma invoice menjadi invoice penjualan ini?";
      this.confirmSetInvoiceType.subTitle = "Invoice type akan menjadi INVOICE dan bersifat final, setelah itu tidak dapat mengubah kembali Invoice tersebut.";
      this.confirmSetInvoiceType.btnConfirm = "btn-primary";
      this.confirmSetInvoiceType.textConfirm = "Ubah Invoice";
      this.confirmSetInvoiceType.action = () => {
        this.axios
          .put("penjualan/set_proforma_to_invoice/" + id)
          .then((res) => {
            this.findObject(this.data, "id", id, (key) => {
              this.data[key].invoice_type = "invoice";
            });

            this.toast("Berhasil ubah invoice");
            this.confirmSetInvoiceType.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirmSetInvoiceType.isSubmit = false;
          });
      };
    },

    _setInvoiceToProforma(id) {
      this.confirmSetInvoiceType.id = id;
      this.confirmSetInvoiceType.title = "Yakin ingin mengubah Invoice menjadi Proforma penjualan ini?";
      this.confirmSetInvoiceType.subTitle = "Invoice type akan menjadi Proforma";
      this.confirmSetInvoiceType.btnConfirm = "btn-primary";
      this.confirmSetInvoiceType.textConfirm = "Ubah Proforma";
      this.confirmSetInvoiceType.action = () => {
        this.axios
          .put("penjualan/set_invoice_to_proforma/" + id)
          .then((res) => {
            this.findObject(this.data, "id", id, (key) => {
              this.data[key].invoice_type = "proforma";
            });
            this.toast("Berhasil mengubah invoice menjadi proforma");
            this.confirmSetInvoiceType.id = null;
          })
          .catch((err) => {
            this.onError(err);
            this.confirmSetInvoiceType.isSubmit = false;
          });
      };
    },

    // _editQty(data) {
    //   let id = data.id;
    //   this.editQuantity.config = { view: true, title: "Ubah Qty" };
    //   this.axios
    //     .get("detail_penjualan/" + id + "/detail")
    //     .then((res) => {
    //       this.editQuantity.data = res.data;
    //     })
    //     .catch((err) => {
    //       this.onError(err);
    //       this.request = false;
    //     });
    //   this.editQuantity.action = (formData) => {
    //     console.log(formData)
    //     this.editQuantity.isSubmit = true;
    //     this.axios
    //       .put(`penjualan/${id}/update_qty_items`, formData)
    //       .then((res) => {
    //         this.toast("Quantity berhasil diubah");
    //         this.editQuantity.isSubmit = false;
    //       })
    //       .catch((err) => {
    //         this.onError(err.response.data.message);
    //         this.editQuantity.isSubmit = false;
    //       });
    //   };
    // },

    _editQty(data) {
      this.editDetail.config = { view: true, title: "Edit Detail Penjualan" };
      this.editDetail.data = data;
      this.editDetail.isEditDetail = true;
    },

    _closed(data) {
      let id = data.id;
      this.closed.config = { view: true, title: "Batalkan Penjualan" };
      this.closed.data = data;
      this.closed.action = (formData) => {
        this.closed.isSubmit = true;
        this.axios
          .post(`penjualan/${id}/close`, formData)
          .then((res) => {
            this.toast("Penjualan berhasil dibatalkan");
            this._get({ silent: true });
            this.closed.isSubmit = false;
          })
          .catch((err) => {
            this.onError(err);
            this.closed.isSubmit = false;
          });
      };
    },

    _detail(data) {
      this.detail.config = { view: true, title: "Detail Penjualan" };
      this.detail.data = data;
    },

    _updatePayment(data) {
      this.updatePayment.config = { view: true, title: "Update Payment Penjualan" };
      this.updatePayment.data = {
        id : data.id,
        tipe_pembayaran : data.tipe_pembayaran
      };
      this.updatePayment.action = (formData) => {
        this.axios
            .put(`penjualan/${formData.id}/payment`, formData)
            .then((res) => {
              this.toast(res.data.message);
              this._get({ silent: true });
            })
            .catch((err) => {
              this.onError(err);
            });
      }
    },

    _checkPenjualanVendorCanClose(data) {
      if(data.inventory_ref_id != null && data.no_invoice != null && !['waiting','closed'].includes(data.status) && this.access.includes('Closed Penjualan Vendor')){
        return true;
      }
      return false;
    },

    _closedByVendor(data){
      if(!this._checkPenjualanVendorCanClose(data)){
        return this.toast("Hubungi Developer untuk mebatalkan invoice");
      }

      this.closed.config = { view: true, title: "Closed Penjualan By Vendor" };
      this.closed.data = data;
      let payloadFailedOrder = {
        data: {
          id: data.inventory_ref_id,
          ref_id: data.no_invoice,
        },
        message: "OK"
      }
      this.closed.action = (formData) => {
        this.closed.isSubmit = true;
        payloadFailedOrder.data.outcome_reason = formData.remark_close
        this.axios
          .post(`order/failed/handling`, payloadFailedOrder)
          .then((res) => {
            this.toast("Penjualan berhasil dibatalkan");
            this._get({ silent: true });
            this.closed.isSubmit = false;
          })
          .catch((err) => {
            this.onError(err);
            this.closed.isSubmit = false;
          });
      };
    },

    _pagePrev() {
      if (this.paginate.currentPage > 1) {
        this.paginate.currentPage--;
        this._get();
      }
    },

    _pageNext() {
      if (this.paginate.to % this.paginate.perPage == 0) {
        this.paginate.currentPage++;
        this._get();
      }
    },

    _pageChange(page) {
      this.paginate.currentPage = page;
      this._get();
    },

    _search(keyword) {
      this.dataFilter.keyword = keyword;
      this.paginate.currentPage = 1;
      this._get();
    },

    _triggerFirestore() {
      fb.firestore
        .collection("trigger_sales")
        .doc("penjualan")
        .onSnapshot((doc) => {
          this.fireTrigger = doc.data().trigger;
        });
    },
    _setApproved(data) {
      this.findObject(this.data, "id", data.id, (key) => {
        this.data[key].status = data.status;
        this.data[key].invoice_type = data.invoice_type;
      });
    },
    _getParams(){
      const noInvoice = this.$route.query['no_invoice'];
      const tanggal = this.$route.query['tanggal'];
      this.dataFilter.start_date = tanggal;
      this.dataFilter.end_date = tanggal;
      this.dataFilter.keyword = noInvoice;
    }

  },

  mounted() {
    this._getParams()
    this.auth = JSON.parse(localStorage.user);
    this.access = JSON.parse(localStorage.permissions);
    this._get();
  },

  created() {
    this._triggerFirestore();
  },

  watch: {
    fireTrigger() {
      // this._get({ silent: true });
    },
  },
};
</script>
